/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import { connect } from 'react-redux'
import { Tabs, Tab } from 'react-bootstrap'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { paymentService } from '../../_services/payment.service'
import { memberService } from '../../_services/member.service'
import Modal from 'react-responsive-modal'
import memberStatuses from '../../_constants/memberStatuses'
import paymentStatuses from '../../_constants/paymentStatuses'
import PicUploaderLinerAdmin from '../Shared/PicUploaderLinerAdmin'
import DatePicker from '../Shared/DatePicker'
import NumberFormat from 'react-number-format'
import UnionSelectForAdmin from '../Shared/UnionSelectForAdmin'
import ClassSelectForAdmin from '../Shared/ClassSelectForAdmin'
import { StatusSelect } from '../Shared/StatusSelect'
import GenderSelectForAdmin from '../Shared/GenderSelectForAdmin'
import moment from 'moment-jalaali' // Notice here !
import RegionSelectForAdmin from '../Shared/RegionSelectForAdmin'
import { saveAs } from 'file-saver'
import FormikCheckbox from '../Shared/FormikCheckbox'

import LicensePrint from './LicensePrint'
import RegistrationPrint from './RegistrationPrint'
import { RiCloseLine } from 'react-icons/ri'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { Input } from 'antd'

import { MdPrint, MdRadioButtonUnchecked } from 'react-icons/md'
import { FiCheckCircle } from 'react-icons/fi'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import ModalImage from 'react-modal-image'

import MemberExams from './MemberExams'

import { config } from '../../config'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})
const base_url = config.apiBaseUrl
export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
)

function checkForDisabledItem(role, memberStatus) {
  // console.log((role, memberStatus));

  if (role === 1 && memberStatus === 4) {
    return true
  } else {
    return false
  }
}

function formatDefaultValue(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e.split('T')[0], 'YYYY-MM-DD')
    if (momentValue.isValid()) {
      return momentValue.format('jYYYY/jMM/jDD')
    }
  }
}
function formatDateTime(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e, 'YYYY-MM-DD HH:mm:ss')
    if (momentValue.isValid()) {
      return momentValue.format('jYYYY/jMM/jDD  ساعت HH:mm:ss')
    }
  }
}

function downloadFile(absoluteUrl) {
  var link = document.createElement('a')
  link.href = absoluteUrl
  link.download = 'true'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  link.remove()
}

const requestData = (pageSize, page, sorted, filtered, dto) => {
  // console.log(dto)
  return new Promise(async (resolve, reject) => {
    // var dto = {};
    dto['pageSize'] = pageSize
    dto['page'] = page + 1
    dto['sorted'] = sorted
    // console.log(JSON.stringify(dto));

    var result = []
    await memberService
      .getAll(JSON.stringify(dto))
      .then(res => {
        // console.log(res)
        result = res
      })
      .catch(() => {
        setTimeout(
          () => requestData(pageSize, page, sorted, filtered, dto),
          2000
        )
      })

    setTimeout(() => resolve(result), 500)
  })
}

class Member extends Component {
  constructor(props, context) {
    super(props, context)
    var pageSize = parseInt(localStorage.getItem('pageSize'), 0)

    this.state = {
      initialItems: [],
      data: [],
      payments: [],
      modal: false,
      modalHeading: '',
      loading: true,
      confirmDeleteShow: false,
      deleteItemIndex: 0,
      pageSize: pageSize ? parseInt(pageSize, 0) : 10,
      selected: {},
      selectAll: 0,
      dto: {},
      model: {},
      EditModalTabsKey: 'info',
      showPrintDialog: false,
      printData: {},
      showRegistrationPrintDialog: false,
      registrationPrintData: {},
      imagePath: undefined,
      showLightbox: false,
      totalRecord: undefined,
      selectedRows: [],
      adModalShow: false,
      selectedIds: []
    }
  }

  componentDidMount() {
    if (this.props.user && this.props.user.role === 1) {
      this.setState({ adModalShow: true })
    }
  }

  handleModalShow = () => {
    this.setState({ modalHeading: 'جستجو', searchModal: true })
  }

  handleSearchModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ searchModal: false })
  }

  handleModalEdit = async id => {
    this.setState({ loading: true })

    await memberService
      .getById(id)
      .then(res => {
        let _model = res.data
        // console.log(_model);

        this.setState({ model: _model }, () => {
          var payments = []
          var dto = {}
          dto['pageSize'] = 100
          dto['page'] = 1
          dto['memberId'] = id

          paymentService
            .getAll(JSON.stringify(dto))
            .then(res => {
              // console.log(res.data.result);

              payments = res.data.result
              this.setState({
                loading: false,
                EditModalTabsKey: 'info',
                modal: true,
                model: _model,
                payments: payments,
                modalHeading:
                  'ویرایش شرکت کننده "' +
                  _model.firstName +
                  ' ' +
                  _model.lastName +
                  '"'
              })
            })
            .catch(error => {
              // console.log(error);
              this.setState({ loading: false })
            })
        })
      })
      .catch(err => {
        // console.log(err);
        this.setState({ loading: false })
      })
  }

  handleModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ modal: false })
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false })
  }

  // getData() {

  //   var dto = {
  //     "page": 1,
  //     "pageSize": 5
  //   }
  //   memberService.getAll(JSON.stringify(dto))
  //     .then((res) => {
  //       console.log(res.data)
  //       var data = res.data;
  //       var pageSize = data.result.length > 10 ? 10 : data.result.length;
  //       this.setState({ initialItems: data, pageSize: pageSize, data: data, loading: false, isSubmitting: false, modal: false });
  //     })
  //     .catch((error) => {
  //       this.setState({ loading: false });
  //     });
  // };

  // handleError(error) {
  //   this.setState({ loading: false });
  //   // // toastr.warning('مشکلی پیش آمد', error);
  // }

  handleDelete = e => {
    let _model = this.state.data[e.target.dataset.index]

    this.setState({ confirmDeleteShow: true, model: _model })
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false })

    memberService
      .delete(this.state.model.id)
      .then(res => {
        toastr.success('حذف شرکت کننده', 'شرکت کننده با موفقیت حذف شد')

        this.table.fireFetchData()
      })
      .catch(error => {
        this.setState({ loading: false })
      })
  }

  handleSearch = values => {
    this.setState({ loading: true })
    // console.log(values);

    const { dto } = this.state
    if (values) {
      Object.entries(values).reduce((acc, [key, value]) => {
        dto[key] = value ? value : undefined
      })
      this.setState({ dto: dto }, () => {
        this.table.fireFetchData()
      })
    }
  }

  handleShowAll = () => {
    var dto = {}
    this.setState({ dto: dto }, () => {
      this.table.fireFetchData()
    })
  }

  handleExportExcel = () => {
    // let ids = [];
    // var { selected } = this.state;
    // ids = Object.keys(selected).filter(function (key) {
    //   return selected[key] === true && key;
    // });

    // let dto = {};
    // dto["memberIds"] = ids;
    // console.log(JSON.stringify(this.state.dto))
    memberService
      .ExportToCsv(JSON.stringify(this.state.dto))
      .then(response => {
        var csvFile = base_url + response.data

        // console.log(csvFile);

        saveAs(csvFile, 'csvFile')
      })
      .catch(error => {
        this.setState({ loading: false })
      })
  }

  handleLicenseIssuance = () => {
    let ids = []
    var { selected } = this.state
    ids = Object.keys(selected).filter(function(key) {
      return selected[key] === true && key
    })

    let dto = {}
    dto['memberIds'] = ids
    // console.log(JSON.stringify(ids))
    memberService
      .License(JSON.stringify(ids))
      .then(res => {
        this.setState({ loading: false })

        toastr.success('عملیات صدور گواهی با موفقیت انجام شد')

        this.table.fireFetchData()
      })
      .catch(error => {
        this.setState({ loading: false })
      })
  }

  handlePrintAllLicences = () => {
    let ids = []
    var { selected } = this.state
    ids = Object.keys(selected).filter(function(key) {
      return selected[key] === true && key
    })

    // console.log(JSON.stringify(ids))
    memberService
      .PrintAllLicenses(JSON.stringify(ids))
      .then(res => {
        let pdf = res.data

        // console.log(pdf);

        saveAs(pdf, 'Licenses')

        this.setState({ loading: false })

        // toastr.success("عملیات صدور گواهی با موفقیت انجام شد")
      })
      .catch(error => {
        // console.log(error);

        this.setState({ loading: false })
      })
  }

  toggleRowSelectAll = isChecked => {
    const allRowIds = this.state.data.map(row => row.id)

    if (isChecked) {
      this.setState({ selectedRows: allRowIds })
    } else {
      this.setState({ selectedRows: [] })
    }
  }

  toggleRowSelection = rowId => {
    const { selectedRows } = this.state
    const isSelected = selectedRows.includes(rowId)

    if (isSelected) {
      this.setState({
        selectedRows: selectedRows.filter(id => id !== rowId)
      })
    } else {
      this.setState({ selectedRows: [...selectedRows, rowId] })
    }
  }

  handleSubmit = values => {
    this.setState({ loading: true })

    // values["imagePath"] = undefined;
    values['createDate'] = undefined
    values['currentClass'] = undefined
    values['union'] = undefined
    values['registerDate'] = undefined
    values['licenseDate'] = undefined
    values['licenseNumber'] = undefined
    values['payments'] = undefined
    if (!values.imagePath) {
      values['imagePath'] = undefined
    }

    // console.log(JSON.stringify(values));
    // var formData = convertToFormData(values)
    memberService
      .edit(JSON.stringify(values))
      .then(res => {
        toastr.success(
          'ویرایش شرکت کننده',
          'شرکت کننده "' +
            values.firstName +
            ' ' +
            values.lastName +
            '" با موفقیت ویرایش شد'
        )
        this.setState({ modal: false })

        this.table.fireFetchData()
      })
      .catch(error => {
        // console.log(error);

        this.setState({ loading: false })
      })
  }

  // componentDidMount(){
  //   this.table.fireFetchData();
  // }

  toggleRow(id) {
    const newSelected = Object.assign({}, this.state.selected)
    newSelected[id] = !this.state.selected[id]
    this.setState({
      selected: newSelected,
      selectAll: 2
    })
  }

  toggleSelectAll() {
    let newSelected = {}

    if (this.state.selectAll === 0) {
      this.state.data.forEach(x => {
        newSelected[x.id] = true
      })
    }
    // console.log(JSON.stringify(newSelected));

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    })
  }
  toggleRow1(id) {
    this.setState(prevState => {
      let updatedIds = [...prevState.selectedIds]

      if (updatedIds.includes(id)) {
        updatedIds = updatedIds.filter(item => item !== id)
      } else {
        updatedIds.push(id)
      }

      return { selectedIds: updatedIds }
    })
  }

  toggleSelectAll1 = () => {
    this.setState(
      prevState => {
        const newSelectedIds =
          prevState.selectedIds.length === prevState.data.length
            ? []
            : prevState.data.map(row => row.id)

        return { selectedIds: newSelectedIds }
      }
    )
  }

  handleSent = () => {
    const { selectedIds } = this.state

    memberService
      .addToOtaghIran(
        JSON.stringify({
          ids: selectedIds
        })
      )
      .then(res => {
        toastr.success('ارسال به اتاق ایران با موفقیت انجام شد.')
        this.setState({ selectedIds: [] })
      })
      .catch(error => {
        toastr.error('عملیات با خطا مواجه شد.')
      })
  }

  fetchData = (state, instance) => {
    // console.log(instance);

    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true })
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered,
      this.state.dto
    )
      .then(res => {
        // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
        // console.log(res.data.result.length );
        // console.log(state.pageSize );
        if (res.data.result) {
          var pageSize =
            res.data.result.length > state.pageSize
              ? state.pageSize
              : res.data.result.length
          // console.log(pageSize );
          this.setState({
            data: res.data.result,
            pages: Math.ceil(res.data.totalRecord / state.pageSize),
            totalRecord: res.data.totalRecord,
            loading: false,
            modal: false,
            searchModal: false,
            pageSize: pageSize
          })
        }
      })
      .catch(() => {
        if (this.table) {
          this.table.fireFetchData()
        }
      })
  }

  handlePrintRegistration = val => {
    this.setState({
      showRegistrationPrintDialog: true,
      registrationPrintData: val
    })
  }

  handlePrintLicence = val => {
    this.setState({ showPrintDialog: true, printData: val })
  }

  render() {
    const ValidationSchema = Yup.object().shape({
      // name: Yup.string().trim().required('نام شرکت کننده'),
    })
    const {
      model,
      loading,
      data,
      pages,
      pageSize,
      dto,
      selected,
      totalRecord
    } = this.state
    // console.log(loading);

    const { user } = this.props

    return (
      // !loading &&
      <div>
        <div style={{ display: 'inline' }}>
          {user && !user.permissions.includes(8) && (
            <a
              onClick={this.handleExportExcel}
              className="btn btn-primary react-table-add-btn "
              style={{ float: 'left' }}
              disabled={data.length === 0}>
              <i className="mdi mdi-file-outline" />
              &nbsp;دریافت فایل اکسل
            </a>
          )}
          {user && (user.role === 0 || user.permissions.includes(7)) && (
            <a
              onClick={() => this.handlePrintAllLicences()}
              className="btn btn-success react-table-add-btn "
              style={{ float: 'left' }}
              disabled={Object.keys(selected).length === 0}>
              <i className="mdi mdi-printer" />
              &nbsp;چاپ گواهی
            </a>
          )}
          {user && (user.role === 0 || user.permissions.includes(3)) && (
            <a
              onClick={this.handleLicenseIssuance}
              className="btn btn-success react-table-add-btn "
              style={{ float: 'left' }}
              disabled={Object.keys(selected).length === 0}>
              <i className="mdi mdi-file-outline" />
              &nbsp;صدور گواهی
            </a>
          )}
          {user && (user.role === 0 || user.permissions.includes(7)) && (
            <a
              onClick={() => this.handleSent()}
              className="btn btn-success react-table-add-btn "
              style={{ float: 'left' }}
              // disabled={Object.keys(selected).length === 0}
            >
              {/* <i className="mdi mdi-check" /> */}
              &nbsp;ارسال به اتاق ایران
            </a>
          )}

          <a
            onClick={this.handleModalShow}
            className="btn btn-primary react-table-add-btn"
            style={{ float: 'right' }}>
            <i className="mdi mdi-magnify" />
            &nbsp;جستجو
          </a>
          <a
            onClick={this.handleShowAll}
            className="btn btn-primary react-table-add-btn"
            style={{ float: 'right' }}>
            <i className="mdi mdi-playlist-check" />
            &nbsp;نمایش همه
          </a>
        </div>

        <br />
        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            manual
            data={data}
            pages={pages}
            loading={loading}
            onFetchData={this.fetchData}
            ref={instance => {
              this.table = instance
            }}
            sorted={this.state.sorted}
            onSortedChange={(newSort, column) => {
              this.setState({ sorted: newSort })
            }}
            onPageSizeChange={pageSize => {
              // const { dispatch } = this.props;
              // dispatch( setPageSize(pageSize) )
              localStorage.setItem('pageSize', pageSize)
              // this.setState({ page: 0 });
            }}
            page={this.state.page}
            onPageChange={page => this.setState({ page })}
            defaultPageSize={pageSize}
            // pageSize={totalRecord && totalRecord > pageSize ? pageSize : totalRecord}
            previousText="صفحه قبل"
            nextText="صفحه بعد"
            loadingText="در حال بارگذاری ..."
            noDataText="نتیجه ای یافت نشد"
            pageText="صفحه"
            ofText="از"
            rowsText="تعداد نمایش"
            getTableProps={() => ({ style: { display: 'block' } })}
            getTrProps={(state, rowInfo, column, instance) => {
              const newSelected = Object.assign({}, this.state.selected)
              const selected = rowInfo
                ? newSelected[rowInfo.original.id]
                : false
              return {
                style: {
                  backgroundColor: selected && '#5079F7',
                  color: selected && 'white'
                }
              }
            }}
            // defaultFilterMethod={(filter, row) =>
            //   String(row[filter.id]) === filter.value}
            columns={[
              {
                Header: () => (
                  <input
                    type="checkbox"
                    onChange={this.toggleSelectAll1}
                    checked={
                      this.state.selectedIds.length === this.state.data.length
                    }
                  />
                ),
                id: 'kajshfdkj',
                sortable: false,
                accessor: '',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                Cell: ({ original }) => (
                  <input
                    type="checkbox"
                    checked={this.state.selectedIds.includes(original.id)}
                    onChange={() => this.toggleRow1(original.id)}
                  />
                )
              },

              {
                Header: 'ردیف',
                id: 'row',
                maxWidth: 50,
                filterable: false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                Cell: row => {
                  return row.index + 1
                }
              },
              {
                Header: 'تصویر',
                accessor: '',
                id: 'imagePath',
                width: 100,
                sortable: false,
                filterable: false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                Cell: row =>
                  row.original.imagePath && (
                    <ModalImage
                      showRotate
                      alt={row.original.firstName + ' ' + row.original.lastName}
                      small={base_url + row.original.imagePath}
                      medium={base_url + row.original.imagePath}
                      large={base_url + row.original.imagePath}
                      hideZoom={true}
                    />
                  )
              },
              {
                Header: 'جنسیت',
                accessor: 'gender',
                id: 'gender',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                Cell: row =>
                  row.original.gender === 0 ? (
                    <i className="mdi mdi-human-male mdi-24px" />
                  ) : (
                    <i className="mdi mdi-human-female mdi-24px" />
                  ),
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                )
              },
              {
                Header: 'نام و نام خانوادگی',
                id: 'fullName',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                accessor: el => el.firstName + el.lastName,
                filterMethod: (filter, row) => {
                  const escapedStr = filter.value.toLowerCase()
                  const termsArr = escapedStr.split(' ')
                  const finalRegexStr = termsArr.reduce(
                    (acc, curr, idx) => acc + '(?=.*' + curr + ')',
                    ''
                  )
                  const regex = new RegExp(finalRegexStr)
                  return regex.test(row[filter.id])
                },
                Cell: props => (
                  <span>
                    {props.original.firstName} {props.original.lastName}
                  </span>
                ),
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                )
              },
              {
                Header: 'تاریخ ثبت نام',
                accessor: 'registerDate',
                id: 'registerDate',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['registerDate'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: props => (
                  <span>{formatDefaultValue(props.original.registerDate)}</span>
                )
              },
              {
                Header: 'شماره موبایل',
                accessor: 'mobile',
                id: 'mobile',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['mobile'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                )
              },
              {
                Header: 'نام اتحادیه',
                accessor: 'union',
                id: 'union',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['name'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: props => <span>{props.original.union.name}</span>
              },
              {
                Header: 'نام کلاس',
                accessor: 'className',
                id: 'className',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['name'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: props => (
                  <span>
                    {props.original.currentClass &&
                      props.original.currentClass.lesson &&
                      props.original.currentClass.lesson.name}
                  </span>
                )
              },
              {
                Header: 'کداتاق ایران',
                accessor: '',
                id: '',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                Cell: props => <span />
              },
              {
                Header: 'وضعیت قبولی',
                accessor: 'passInExam',
                id: 'passInExam',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                Cell: props =>
                  props.original.passInExam ? (
                    <FiCheckCircle
                      size="22px"
                      color="#1890FF"
                      title="قبول شده"
                    />
                  ) : (
                    <MdRadioButtonUnchecked
                      size="22px"
                      color="#9a9a9a"
                      title="قبول نشده"
                    />
                  )
              },
              {
                Header: 'غیر حضوری',
                accessor: 'hasExam',
                id: 'hasExam',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                Cell: props =>
                  props.original.hasExam ? (
                    <FiCheckCircle
                      size="22px"
                      color="#1890FF"
                      title="غیر حضوری"
                    />
                  ) : (
                    <MdRadioButtonUnchecked
                      size="22px"
                      color="#9a9a9a"
                      title=""
                    />
                  )
              },
              {
                Header: 'وضعیت پرداخت',
                accessor: 'paymentStatus',
                id: 'paymentStatus',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                Cell: props =>
                  props.original.paymentStatus ? (
                    <FiCheckCircle
                      size="22px"
                      color="#1890FF"
                      title="پرداخت شده"
                    />
                  ) : (
                    <MdRadioButtonUnchecked
                      size="22px"
                      color="#9a9a9a"
                      title="پرداخت نشده"
                    />
                  )
              },
              {
                Header: 'چاپ رسید ثبت نام',
                accessor: 'memberStatus',
                id: 'memberStatus',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                Cell: props => (
                  <a
                    onClick={() =>
                      this.handlePrintRegistration(props.original)
                    }>
                    <MdPrint size="32px" style={{ verticalAlign: 'middle' }} />
                  </a>
                )
              },
              {
                Header: 'چاپ گواهی',
                accessor: 'memberStatus',
                id: 'memberStatus',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                show:
                  user &&
                  (user.role === 0 || user.permissions.includes(7)) &&
                  !user.permissions.includes(8)
                    ? true
                    : false,
                Cell: props =>
                  props.original.memberStatus === 4 &&
                  props.original.licenseNumber ? (
                    <a onClick={() => this.handlePrintLicence(props.original)}>
                      <MdPrint
                        size="32px"
                        style={{ verticalAlign: 'middle' }}
                      />
                    </a>
                  ) : (
                    ''
                  )
              },
              // {
              //     Header: "هزینه",
              //     accessor: "amount",
              //     id: "amount",
              //     style: { display: 'flex', alignItems: 'center', 'justifyContent': 'center' },
              //     filterMethod: (filter, rows) =>
              //         matchSorter(rows, filter.value, { keys: ["amount"] }),
              //     filterAll: true,
              //     Filter: ({ onChange }) =>
              //         <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
              //     Cell: props => (
              //         <NumberFormat thousandSeparator={true}
              //             className="numberFa"
              //             value={props.original.amount}
              //             displayType="text"
              //             suffix="ریال"
              //         />
              //     )
              // },
              {
                Header: 'ویرایش',
                accessor: 'id',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                sortable: false,
                filterable: false,
                //                     Filter: ({ filter, onChange }) =>
                //                         <a onClick={this.handleModalCreate} className="btn btn-primary react-table-add-btn"
                //                         ><i className="mdi mdi-plus"></i>
                //                             افزودن شرکت کننده جدید
                // </a>,
                show: user && !user.permissions.includes(8) ? true : false,
                Cell: row => (
                  <div>
                    <a
                      onClick={() => this.handleModalEdit(row.original.id)}
                      className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn"
                      rel="tooltip"
                      data-original-title="ویرایش">
                      <i className="mdi mdi-pencil" />
                    </a>
                    {user && user.role !== 1 && (
                      <a
                        onClick={this.handleDelete}
                        data-index={row.index}
                        className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn"
                        data-original-title="حذف"
                        rel="tooltip">
                        <i data-index={row.index} className="mdi mdi-delete" />
                      </a>
                    )}
                  </div>
                )
              },
              {
                id: 'checkbox',
                accessor: '',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'selectAllCheckBoxHeader',
                show: user && !user.permissions.includes(8) ? true : false,
                Cell: ({ original }) => {
                  return (
                    <label className="input react-table-checkbox">
                      <input
                        className="input__field"
                        type="checkbox"
                        checked={this.state.selected[original.id] === true}
                        onChange={() => this.toggleRow(original.id)}
                      />
                      <span className="input__text" />
                    </label>
                  )
                },
                // Filter: () =>
                //   <label className="input react-table-checkbox">
                //     <input
                //       className="input__field"
                //       type="checkbox"
                //       checked={this.state.selectAll === 1}
                //       ref={input => {
                //         if (input) {
                //           input.indeterminate = this.state.selectAll === 2;
                //         }
                //       }}
                //       onChange={() => this.toggleSelectAll()}
                //     />
                //     <span className="input__text"></span>
                //   </label>,
                Header: () => (
                  <label className="input react-table-checkbox">
                    <input
                      className="input__field"
                      type="checkbox"
                      checked={this.state.selectAll === 1}
                      ref={input => {
                        if (input) {
                          input.indeterminate = this.state.selectAll === 2
                        }
                      }}
                      onChange={() => this.toggleSelectAll()}
                    />
                    <span className="input__text" />
                  </label>
                ),
                // <a onClick={this.handleDeleteSelected}
                //   className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn"
                //   disabled={Object.keys(this.state.selected).length === 0}>
                //   <i className="mdi mdi-delete"></i>
                // </a>
                sortable: false,
                maxWidth: 100
              }
            ]}
            // key={this.state.pageSize}
            // defaultPageSize={this.state.pageSize}
            className="-striped -highlight"
          />
        </div>
        <LicensePrint
          data={this.state.printData}
          show={this.state.showPrintDialog}
          onClose={() => this.setState({ showPrintDialog: false })}
        />
        <RegistrationPrint
          data={this.state.registrationPrintData}
          show={this.state.showRegistrationPrintDialog}
          onClose={() => this.setState({ showRegistrationPrintDialog: false })}
        />
        <Modal
          open={this.state.searchModal}
          onClose={this.handleSearchModalHide}
          center
          classNames={{
            overlay: 'customOverlay',
            modal: 'customModal lg',
            closeButton: 'customModalCloseButton'
          }}>
          <Formik
            initialValues={dto}
            onSubmit={(values, { setSubmitting }) => {
              // console.log(values);
              this.handleSearch(values)
              setSubmitting(false)
            }}
            validationSchema={ValidationSchema}>
            {props => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                setFieldValue,
                handleSubmit
              } = props
              return (
                <div className="row" style={{ position: 'relative' }}>
                  <div className="col-md-12">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="form-inline">
                          <div className="col-md-2 text-left">
                            <label>اتحادیه</label>
                          </div>
                          <div className="col-md-10 rtl">
                            <UnionSelectForAdmin
                              required
                              defaultValue={values.unionId}
                              onChange={val => {
                                setFieldValue('unionId', val)
                              }}
                              style={{
                                height: 40,
                                background: '#fff',
                                border: 'thin solid #b4b4b4',
                                borderRadius: 7
                              }}
                            />
                            <ErrorMessage
                              component={ErrorPopUp}
                              name="unionId"
                            />
                          </div>

                          <br />
                          <br />
                          <div className="clearfix" />

                          <div className="col-md-2 text-left">
                            <label>تقویم کلاس</label>
                          </div>
                          <div className="col-md-10 rtl">
                            <ClassSelectForAdmin
                              required
                              defaultValue={values.classId}
                              onChange={val => {
                                setFieldValue('classId', val)
                              }}
                            />
                            <ErrorMessage
                              component={ErrorPopUp}
                              name="classId"
                            />
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2 text-left">
                            <label>نام</label>
                          </div>
                          <div className="col-md-4 ">
                            <Field
                              component={Input}
                              allowClear
                              onChange={e => {
                                setFieldValue('firstName', e.target.value)
                              }}
                              value={values.firstName}
                              name="firstName"
                            />
                            {getIn(errors, 'firstName') &&
                            getIn(touched, 'firstName') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.firstName}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="col-md-2 text-left">
                            <label>نام خانوادگی</label>
                          </div>
                          <div className="col-md-4">
                            <Field
                              component={Input}
                              allowClear
                              onChange={e => {
                                setFieldValue('lastName', e.target.value)
                              }}
                              value={values.lastName}
                              name="lastName"
                            />
                            {getIn(errors, 'lastName') &&
                            getIn(touched, 'lastName') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.lastName}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2 text-left">
                            <label>کد ملی</label>
                          </div>
                          <div className="col-md-4">
                            <NumberFormat
                              format="##########"
                              isNumericString
                              allowNegative={false}
                              name="nationalCode"
                              onChange={e => {
                                setFieldValue('nationalCode', e.target.value)
                              }}
                              value={values.nationalCode}
                              className="text-input"
                            />

                            {getIn(errors, 'nationalCode') &&
                            getIn(touched, 'nationalCode') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.nationalCode}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="col-md-2 text-left">
                            <label>شماره موبایل</label>
                          </div>
                          <div className="col-md-4">
                            <NumberFormat
                              isNumericString
                              allowNegative={false}
                              format="###########"
                              defaultValue={values.mobile}
                              name="mobile"
                              onChange={e => {
                                setFieldValue('mobile', e.target.value)
                              }}
                              className="text-input"
                            />
                            {getIn(errors, 'mobile') &&
                            getIn(touched, 'mobile') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.mobile}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2 text-left">
                            <label />
                          </div>
                          <div className="col-md-10">
                            <Field
                              component={FormikCheckbox}
                              name="onlyExamPass"
                              id="onlyExamPass"
                              label={'کسانی که در آزمون الکترونیکی شرکت کردن'}
                            />
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2 text-left">
                            <label />
                          </div>
                          <div className="col-md-10">
                            <Field
                              component={FormikCheckbox}
                              name="onlyExamPassAndNeedLicense"
                              id="onlyExamPassAndNeedLicense"
                              label={'در انتظار صدور گواهی'}
                            />
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-12">
                            <button
                              type="submit"
                              className={'icon button submit-btn pull-left'}
                              disabled={isSubmitting}>
                              {loading && (
                                <i className="mdi mdi-spin mdi-loading" />
                              )}
                              &nbsp; جستجو &nbsp;
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              )
            }}
          </Formik>
        </Modal>

        <Dialog
          maxWidth="md"
          fullWidth
          className="message-dialog"
          open={this.state.modal}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleModalHide()}>
          <DialogContent>
            <a
              className="dialog-close-btn"
              onClick={() => this.handleModalHide()}>
              <RiCloseLine />
            </a>
            <div>
              <Tabs
                transition={false}
                id="controlled-tab-example"
                className="previewTabs"
                activeKey={this.state.EditModalTabsKey}
                onSelect={EditModalTabsKey =>
                  this.setState({ EditModalTabsKey })
                }>
                <Tab eventKey="info" title="اطلاعات شرکت کننده">
                  <Formik
                    initialValues={model}
                    enableReinitialize
                    onSubmit={(values, { setSubmitting }) => {
                      // console.log(values);
                      this.handleSubmit(values)
                      setSubmitting(false)
                    }}
                    validationSchema={ValidationSchema}>
                    {props => {
                      const {
                        values,
                        touched,
                        errors,
                        isSubmitting,
                        handleChange,
                        handleBlur,
                        setFieldValue,
                        handleSubmit
                      } = props
                      return (
                        <div className="row" style={{ position: 'relative' }}>
                          <div className="col-md-12">
                            <form onSubmit={handleSubmit}>
                              <div className="row">
                                <div className="form-inline">
                                  {/* <div className="col-md-2 text-left">
                                                        <label>تقویم کلاس</label>
                                                    </div>
                                                    <div className="col-md-10 rtl">
                                                        <ClassSelect
                                                            required
                                                            defaultValue={values.classId}
                                                            onChange={(val) => {
                                                                setFieldValue('classId', val);
                                                            }}
                                                        />
                                                        <ErrorMessage component={ErrorPopUp} name="classId" />
                                                    </div>

                                                    <div className="clearfix"></div> */}

                                  <div className="col-md-2 text-left">
                                    <label>تصویر</label>
                                  </div>
                                  <div className="col-md-4">
                                    <PicUploaderLinerAdmin
                                      label="انتخاب تصویر"
                                      defaultValue={values.imagePath}
                                      onChange={val => {
                                        // console.log(val);
                                        setFieldValue('imagePath', val)
                                      }}
                                    />
                                    {getIn(errors, 'imagePath') &&
                                    getIn(touched, 'imagePath') ? (
                                      <div
                                        className={
                                          'required_validator visible'
                                        }>
                                        <div className="validator_container">
                                          <span>{errors.imagePath}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label>اتحادیه</label>
                                  </div>
                                  <div className="col-md-10 rtl">
                                    <UnionSelectForAdmin
                                      disabled={
                                        user.role === 1 &&
                                        values.memberStatus === 4
                                      }
                                      required
                                      defaultValue={values.unionId}
                                      onChange={val => {
                                        setFieldValue('unionId', val)
                                      }}
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="unionId"
                                    />
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label>کلاس</label>
                                  </div>
                                  <div className="col-md-10 rtl">
                                    <ClassSelectForAdmin
                                      disabled={
                                        user.role === 1 &&
                                        values.memberStatus === 4
                                      }
                                      required
                                      defaultValue={values.classId}
                                      onChange={val => {
                                        setFieldValue('classId', val)
                                      }}
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="classId"
                                    />
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label>جنسیت</label>
                                  </div>
                                  <div className="col-md-4">
                                    <GenderSelectForAdmin
                                      required
                                      defaultValue={values.gender}
                                      onChange={val => {
                                        setFieldValue('gender', val)
                                      }}
                                    />
                                    {getIn(errors, 'gender') &&
                                    getIn(touched, 'gender') ? (
                                      <div
                                        className={
                                          'required_validator visible'
                                        }>
                                        <div className="validator_container">
                                          <span>{errors.gender}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>

                                  <div className="col-md-2 text-left">
                                    <label />
                                  </div>
                                  <div className="col-md-4 text-left">
                                    <Field
                                      component={FormikCheckbox}
                                      name="isIsargar"
                                      id="isIsargar"
                                      label={'شرکت کننده ایثار گر است'}
                                    />
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label>نام</label>
                                  </div>
                                  <div className="col-md-4">
                                    <Field
                                      type="text"
                                      value={values.firstName}
                                      onBlur={handleBlur}
                                      name="firstName"
                                      touched={touched.firstName}
                                      className={
                                        getIn(errors, 'firstName') &&
                                        getIn(touched, 'firstName')
                                          ? 'text-input has-error rtl'
                                          : 'text-input required rtl'
                                      }
                                    />
                                    {getIn(errors, 'firstName') &&
                                    getIn(touched, 'firstName') ? (
                                      <div
                                        className={
                                          'required_validator visible'
                                        }>
                                        <div className="validator_container">
                                          <span>{errors.firstName}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>

                                  <div className="col-md-2 text-left">
                                    <label>نام خانوادگی</label>
                                  </div>
                                  <div className="col-md-4">
                                    <Field
                                      type="text"
                                      value={values.lastName}
                                      onBlur={handleBlur}
                                      name="lastName"
                                      touched={touched.lastName}
                                      className={
                                        getIn(errors, 'lastName') &&
                                        getIn(touched, 'lastName')
                                          ? 'text-input has-error rtl'
                                          : 'text-input required rtl'
                                      }
                                    />
                                    {getIn(errors, 'lastName') &&
                                    getIn(touched, 'lastName') ? (
                                      <div
                                        className={
                                          'required_validator visible'
                                        }>
                                        <div className="validator_container">
                                          <span>{errors.lastName}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label>کد ملی</label>
                                  </div>
                                  <div className="col-md-4">
                                    <NumberFormat
                                      format="##########"
                                      isNumericString
                                      allowNegative={false}
                                      name="nationalCode"
                                      onChange={e => {
                                        setFieldValue(
                                          'nationalCode',
                                          e.target.value
                                        )
                                      }}
                                      onBlur={handleBlur}
                                      value={values.nationalCode}
                                      className={
                                        errors.nationalCode &&
                                        touched.nationalCode
                                          ? 'text-input numberFa has-error'
                                          : 'text-input numberFa required'
                                      }
                                    />

                                    {getIn(errors, 'nationalCode') &&
                                    getIn(touched, 'nationalCode') ? (
                                      <div
                                        className={
                                          'required_validator visible'
                                        }>
                                        <div className="validator_container">
                                          <span>{errors.nationalCode}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>

                                  <div className="col-md-2 text-left">
                                    <label>شماره شناسنامه</label>
                                  </div>
                                  <div className="col-md-4">
                                    <NumberFormat
                                      isNumericString
                                      allowNegative={false}
                                      name="idNumber"
                                      onChange={e => {
                                        setFieldValue(
                                          'idNumber',
                                          e.target.value
                                        )
                                      }}
                                      onBlur={handleBlur}
                                      value={values.idNumber}
                                      className={
                                        errors.idNumber && touched.idNumber
                                          ? 'text-input numberFa has-error'
                                          : 'text-input numberFa required'
                                      }
                                    />

                                    {getIn(errors, 'idNumber') &&
                                    getIn(touched, 'idNumber') ? (
                                      <div
                                        className={
                                          'required_validator visible'
                                        }>
                                        <div className="validator_container">
                                          <span>{errors.idNumber}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label style={{ lineHeight: 'unset' }}>
                                      تصویر کارت ملی
                                      {/* <br /><span style={{ color: '#d8848e', fontSize: '11px', paddingLeft: 15 }}>ابعاد 3 * 4</span> */}
                                    </label>
                                  </div>
                                  <div className="col-md-4">
                                    <PicUploaderLinerAdmin
                                      label="انتخاب فایل تصویر کارت ملی"
                                      defaultValue={values.codeMeliImagePath}
                                      onChange={val => {
                                        // console.log(val);
                                        setFieldValue('codeMeliImagePath', val)
                                      }}
                                    />
                                    {getIn(errors, 'codeMeliImagePath') &&
                                    getIn(touched, 'codeMeliImagePath') ? (
                                      <div
                                        className={
                                          'required_validator visible'
                                        }>
                                        <div className="validator_container">
                                          <span>
                                            {errors.codeMeliImagePath}
                                          </span>
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>

                                  <div className="col-md-2 text-left">
                                    <label>نام پدر</label>
                                  </div>
                                  <div className="col-md-4">
                                    <Field
                                      type="text"
                                      value={values.fatherName}
                                      onBlur={handleBlur}
                                      name="fatherName"
                                      touched={touched.fatherName}
                                      className={
                                        getIn(errors, 'fatherName') &&
                                        getIn(touched, 'fatherName')
                                          ? 'text-input has-error rtl'
                                          : 'text-input required rtl'
                                      }
                                    />
                                    {getIn(errors, 'fatherName') &&
                                    getIn(touched, 'fatherName') ? (
                                      <div
                                        className={
                                          'required_validator visible'
                                        }>
                                        <div className="validator_container">
                                          <span>{errors.fatherName}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label>تاریخ تولد</label>
                                  </div>
                                  <div className="col-md-4">
                                    <DatePicker
                                      name="expireDate"
                                      // maxDate={moment()}
                                      defaultValue={values.birthDate}
                                      required
                                      onChange={val => {
                                        setFieldValue('birthDate', val)
                                      }}
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="birthDate"
                                    />
                                  </div>

                                  <div className="col-md-2 text-left">
                                    <label>صادره از</label>
                                  </div>
                                  <div className="col-md-4">
                                    <Field
                                      type="text"
                                      value={values.birthPlace}
                                      onBlur={handleBlur}
                                      name="birthPlace"
                                      touched={touched.birthPlace}
                                      className={
                                        getIn(errors, 'birthPlace') &&
                                        getIn(touched, 'birthPlace')
                                          ? 'text-input has-error rtl'
                                          : 'text-input required rtl'
                                      }
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="birthPlace"
                                    />
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label>شماره موبایل</label>
                                  </div>
                                  <div className="col-md-4">
                                    <NumberFormat
                                      isNumericString
                                      allowNegative={false}
                                      format="###########"
                                      defaultValue={values.mobile}
                                      name="mobile"
                                      onChange={e => {
                                        setFieldValue('mobile', e.target.value)
                                      }}
                                      onBlur={handleBlur}
                                      className={
                                        getIn(errors, 'mobile') &&
                                        getIn(touched, 'mobile')
                                          ? 'text-input numberFa has-error rtl'
                                          : 'text-input numberFa required rtl'
                                      }
                                    />
                                    {getIn(errors, 'mobile') &&
                                    getIn(touched, 'mobile') ? (
                                      <div
                                        className={
                                          'required_validator visible'
                                        }>
                                        <div className="validator_container">
                                          <span>{errors.mobile}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>

                                  <div className="col-md-2 text-left">
                                    <label>تلفن ثابت</label>
                                  </div>
                                  <div className="col-md-4">
                                    <Field
                                      type="text"
                                      value={values.tels}
                                      onBlur={handleBlur}
                                      name="tels"
                                      touched={touched.tels}
                                      className={
                                        getIn(errors, 'tels') &&
                                        getIn(touched, 'tels')
                                          ? 'text-input has-error rtl'
                                          : 'text-input required rtl'
                                      }
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="tels"
                                    />
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label style={{ lineHeight: 'unset' }}>
                                      کد رهگیری
                                      <br />
                                      <span
                                        style={{
                                          fontSize: '11px',
                                          paddingLeft: 2
                                        }}>
                                        شناسه صنفی
                                      </span>
                                    </label>
                                  </div>
                                  <div className="col-md-4">
                                    <Field
                                      type="text"
                                      value={values.senfNumber}
                                      onBlur={handleBlur}
                                      name="senfNumber"
                                      touched={touched.senfNumber}
                                      className={
                                        getIn(errors, 'senfNumber') &&
                                        getIn(touched, 'senfNumber')
                                          ? 'text-input has-error rtl'
                                          : 'text-input required rtl'
                                      }
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="senfNumber"
                                    />
                                  </div>

                                  <div className="col-md-2 text-left">
                                    <label
                                      style={{
                                        direction: 'rtl',
                                        textAlign: 'left'
                                      }}>
                                      کد isic
                                    </label>
                                  </div>
                                  <div className="col-md-4">
                                    <Field
                                      type="text"
                                      value={values.isicCode}
                                      onBlur={handleBlur}
                                      name="isicCode"
                                      touched={touched.isicCode}
                                      className={
                                        getIn(errors, 'isicCode') &&
                                        getIn(touched, 'isicCode')
                                          ? 'text-input has-error rtl'
                                          : 'text-input required rtl'
                                      }
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="isicCode"
                                    />
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label>منطقه شهرداری</label>
                                  </div>
                                  <div className="col-md-4 rtl">
                                    <RegionSelectForAdmin
                                      defaultValue={values.region}
                                      onChange={val => {
                                        setFieldValue('region', val)
                                      }}
                                    />
                                    {getIn(errors, 'region') &&
                                    getIn(touched, 'region') ? (
                                      <div
                                        className={
                                          'required_validator visible'
                                        }>
                                        <div className="validator_container">
                                          <span>{errors.region}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>

                                  <div className="col-md-2 text-left">
                                    <label>کد پستی</label>
                                  </div>
                                  <div className="col-md-4">
                                    <NumberFormat
                                      isNumericString
                                      allowNegative={false}
                                      format="##########"
                                      defaultValue={values.codePosti}
                                      name="codePosti"
                                      onChange={e => {
                                        setFieldValue(
                                          'codePosti',
                                          e.target.value
                                        )
                                      }}
                                      onBlur={handleBlur}
                                      className={
                                        getIn(errors, 'codePosti') &&
                                        getIn(touched, 'codePosti')
                                          ? 'text-input numberFa has-error rtl'
                                          : 'text-input numberFa required rtl'
                                      }
                                    />
                                    {getIn(errors, 'codePosti') &&
                                    getIn(touched, 'codePosti') ? (
                                      <div
                                        className={
                                          'required_validator visible'
                                        }>
                                        <div className="validator_container">
                                          <span>{errors.codePosti}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label
                                      style={{
                                        direction: 'rtl',
                                        textAlign: 'left'
                                      }}>
                                      نشانی واحد صنفی
                                    </label>
                                  </div>
                                  <div className="col-md-10">
                                    <Field
                                      type="text"
                                      value={values.address}
                                      onBlur={handleBlur}
                                      name="address"
                                      touched={touched.address}
                                      className={
                                        getIn(errors, 'address') &&
                                        getIn(touched, 'address')
                                          ? 'text-input has-error rtl'
                                          : 'text-input required rtl'
                                      }
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="address"
                                    />
                                  </div>

                                  <div className="clearfix" />

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label>وضعیت</label>
                                  </div>
                                  <div className="col-md-4 rtl">
                                    <StatusSelect
                                      disabled={
                                        user.role === 1 &&
                                        values.memberStatus === 4
                                      }
                                      required
                                      defaultValue={values.memberStatus}
                                      onChange={val => {
                                        setFieldValue('memberStatus', val)
                                      }}
                                      style={{
                                        height: 40,
                                        background: '#fff',
                                        border: 'thin solid #b4b4b4',
                                        borderRadius: 7
                                      }}
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="unionId"
                                    />
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-2 text-left">
                                    <label>شماره گواهی</label>
                                  </div>
                                  <div className="col-md-4 rtl">
                                    <input
                                      type="text"
                                      class="text-input rtl"
                                      disabled
                                      defaultValue={
                                        values.licenseNumber
                                          ? values.licenseNumber
                                          : ''
                                      }
                                    />
                                  </div>

                                  <div className="col-md-2 text-left">
                                    <label>تاریخ گواهی</label>
                                  </div>
                                  <div className="col-md-4 rtl">
                                    <input
                                      type="text"
                                      class="text-input rtl"
                                      disabled
                                      defaultValue={
                                        values.licenseDate
                                          ? formatDefaultValue(
                                              values.licenseDate
                                            )
                                          : ''
                                      }
                                    />
                                  </div>

                                  <div className="clearfix" />

                                  <div className="col-md-12">
                                    <br />
                                    <input
                                      type="hidden"
                                      name="id"
                                      value={values.id}
                                    />
                                    {user && user.role !== 1 && (
                                      <button
                                        type="submit"
                                        className={
                                          'icon button submit-btn pull-left'
                                        }
                                        disabled={isSubmitting}>
                                        {loading && (
                                          <i className="mdi mdi-spin mdi-loading" />
                                        )}
                                        &nbsp; ذخیره &nbsp;
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      )
                    }}
                  </Formik>
                </Tab>

                <Tab eventKey="payments" title="اطلاعات پرداخت">
                  <table className="table table-striped text-center table-bordered table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">ردیف</th>
                        <th className="text-center">تاریخ</th>
                        <th className="text-center">مبلغ</th>
                        <th className="text-center">وضعیت</th>
                        <th className="text-center">کد رهگیری</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.payments.map((item, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{formatDateTime(item.createDate)}</td>
                          <td>
                            <NumberFormat
                              thousandSeparator={true}
                              className="numberFa"
                              value={item.amount}
                              displayType="text"
                              suffix=" ریال"
                            />
                          </td>
                          <td>
                            {
                              paymentStatuses.filter(
                                el => el.id === item.paymentStatus
                              )[0].name
                            }
                          </td>
                          <td>{item.referCode}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Tab>
                {user && user.role === 0 && (
                  <Tab eventKey="exams" title="آزمونهای کاربر">
                    {this.state.EditModalTabsKey === 'exams' && (
                      <MemberExams id={model.id} />
                    )}
                  </Tab>
                )}
              </Tabs>
            </div>
          </DialogContent>
        </Dialog>

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={
            'آیا از حذف  [' +
            this.state.model.firstName +
            ' ' +
            this.state.model.lastName +
            '] مطمئن هستید؟'
          }
        />
        {this.state.loading ? <Loading /> : ''}

        <Dialog
          maxWidth="sm"
          fullWidth
          className="ad-dialog"
          open={this.state.adModalShow}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.setState({ adModalShow: false })}>
          <DialogContent>
            <a
              className="dialog-close-btn"
              onClick={() => this.setState({ adModalShow: false })}>
              <RiCloseLine />
            </a>
            <a
              href="http://rahbord.org/images/Union_Automation.pdf"
              target="_blank">
              <img
                src="http://rahbord.org/images/ads_rahbord.jpg"
                alt=""
                className="ad-image"
              />
            </a>
          </DialogContent>
        </Dialog>
      </div>
    )
  }
}

// export default Member;

function mapStateToProps(state) {
  const { authentication } = state
  const { user } = authentication
  return {
    user
  }
}

const connectedMember = connect(mapStateToProps)(Member)
export { connectedMember as Member }
